export default __webpack_public_path__ + "images/assets/bf27ac8bc18687633e6caf5d1dce2798.svg";